import { useState, useEffect } from "react";
import i18n, { setLang } from "@/i18n";

const OPTIONS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

export default function LanguageSwitcher() {
  const [current, setCurrent] = useState(i18n.language || "it");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (lng) => setCurrent(lng);
    i18n.on("languageChanged", handler);
    return () => i18n.off("languageChanged", handler);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (!e.target.closest("[data-lang-switcher]")) setOpen(false);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [open]);

  const activeFlag = (OPTIONS.find((o) => current.startsWith(o.code)) || OPTIONS[0]).flag;

  return (
    <div className="relative" data-lang-switcher data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-11 h-11 grid place-items-center rounded-full bg-white border border-[#ECEEF5] text-xl leading-none shadow-sm hover:border-[#1A2A6C]/30 hover:bg-[#F5F6FA] transition-all"
        aria-label="Cambia lingua / Change language"
        data-testid="language-switcher-toggle"
      >
        <span aria-hidden="true">{activeFlag}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-12 z-40 w-40 rounded-2xl bg-white border border-[#ECEEF5] shadow-[0_10px_30px_rgba(20,32,80,0.12)] overflow-hidden anim-pop-in" role="menu">
          {OPTIONS.map((o) => (
            <button
              key={o.code}
              type="button"
              onClick={() => { setLang(o.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2.5 text-sm font-semibold hover:bg-[#F5F6FA] ${current.startsWith(o.code) ? "text-[#1A2A6C] bg-[#F5F6FA]" : "text-[#1A1D29]"}`}
              data-testid={`language-option-${o.code}`}
            >
              <span className="text-lg leading-none" aria-hidden="true">{o.flag}</span>
              <span>{o.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
